const ONLY_NUMBER = 'Chỉ nhập số từ 0-9';
const EMPTY_EXPENSE = 'Chọn 1 khoản chi';
const OUT_OF_RANGE = 'Vượt quá giới hạn cho phép';
const LARGER_THAN_0 = 'Nhập số tiền chi';
const SUCCESS_MSG = 'Thêm thành công';

export { OUT_OF_RANGE, EMPTY_EXPENSE, ONLY_NUMBER, LARGER_THAN_0, SUCCESS_MSG };
